import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { FieldsClassificationRoute } from '../../routing'

export  class FieldClassificationPage extends Component {
    render() {
        return (
            <Fragment>
            <Breadcrumbs />
            <FieldsClassificationRoute />
          </Fragment>
        )
    }
}
